<template>
    <div class="CampCart">
        <div class="CampCart--title">
            <div class="CampCart--title-name" :title="camp.campName">{{camp.campName}}</div>
            <div class="CampCart--title-date">{{camp.campStartDate | timeFormatL}} - {{camp.campEndDate | timeFormatL}}
            </div>
        </div>

        <div class="CampCart--second">
            <div class="CampCart--second-location">
                <img src="../../../../assets/img/svg/map-pin.svg">
                <span class="CampCart--second-location-name">{{camp.locationName }}</span>
            </div>
            <div class="CampCart--second-days">
                <div :class="{disabled: !camp.sunday}">Sun</div>
                <div :class="{disabled: !camp.monday}">Mon</div>
                <div :class="{disabled: !camp.tuesday}">Tue</div>
                <div :class="{disabled: !camp.wednesday}">Wed</div>
                <div :class="{disabled: !camp.thursday}">Thu</div>
                <div :class="{disabled: !camp.friday}">Fri</div>
                <div :class="{disabled: !camp.saturday}">Sat</div>
            </div>
        </div>

        <div class="CampCart--content">
            <div class="CampCart--content-info">
                <p :class="isOpened ? 'CampCart--content-info-text-full' : 'CampCart--content-info-text-small'"
                   v-html="camp.description"
                />
                <transition name="fade">
                    <div v-if="!isOpened"
                         class="description-shadow"
                    />
                </transition>
            </div>

            <div class="CampCart--content-more"
                 @click="toggleCart"
            >
                <i class="material-icons down" :class="isOpened ? 'rotated': 'rotatedBack'">keyboard_arrow_down</i>
            </div>

            <div class="CampCart--content-pricings"
                 v-for="pricing of camp.pricings"
                 :key="pricing.id"
            >
                <camp-pricing-cart :pricing="pricing"
                                   @open="$emit('open', pricing)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { ExpandAnimationMixin } from '@/mixins/expandAnimationMixin';

    export default {
        name: 'CampCart',

        components: {
            CampPricingCart: () => import('@/components/dashboard/pages/Activities/CampPricingCart')
        },

        props: {
            camp: {
                type: Object,
                required: false
            }
        },

        data() {
            return {
                isOpened: false
            }
        },

        mixins: [ExpandAnimationMixin],

        methods: {
            toggleCart() {
                this.isOpened = !this.isOpened;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/styles/variables/colors';

    .CampCart {
        width: 100%;
        padding: 28px 30px 25px;
        border-radius: 4px;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
        background-color: $White;

        &--title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 17px;

            @media screen and (max-width: 700px) {
                flex-direction: column;
                justify-content: space-between;
                margin-bottom: 10px;
            }

            &-name {
                margin-bottom: 0;
                cursor: default;
                font-size: 24px;
                font-weight: 700;
                line-height: 1.33;
                word-break: break-word;
                color: $Dark;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                    word-break: break-all;
                }
            }

            &-date {
                font-size: 14px;
                font-weight: 400;
                color: $WhiteGrey;

                @media screen and (max-width: 700px) {
                    margin-top: 10px;
                }
            }
        }

        &--second {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            @media screen and (max-width: 700px) {
                flex-direction: column;
                justify-content: space-between;
            }

            &-location {
                display: flex;
                align-items: center;

                img {
                    height: 10px;
                    width: 13px;
                }

                &-name {
                    text-transform: capitalize;
                    font-weight: 400;
                    font-size: 14px;
                    word-break: break-word;
                    color: $Light-dark;
                    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                        word-break: break-all;
                    }
                }
            }

            &-days {
                display: flex;
                justify-content: space-between;

                @media screen and (max-width: 700px) {
                    margin-top: 10px;
                }

                > div {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    font-size: 11px;
                    font-weight: 400;
                    color: $ShoppingCartTextColor;
                    background-color: $ComplementaryBgTxtDarker;

                    &:not(:last-child) {
                        margin-right: 20px;

                        @media screen and (max-width: 700px) {
                            margin-right: 10px;
                        }
                    }
                }

                .disabled {
                    color: $WhiteGrey;
                    background-color: $ComplementaryBackgroundLightGrey;
                }
            }
        }

        &--content {
            &-info {
                position: relative;
                font-size: 15px;
                font-weight: 400;
                line-height: 1.6;
                color: $Dark;
                word-break: break-word;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                    word-break: break-all;
                }

                .description-shadow {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 49px;
                    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.54) 54%, #ffffff)
                }

                &-text-small {
                    height: 60px;
                    overflow: hidden;
                }

                &-text-full {
                    animation: accordion 15s forwards;
                }
            }

            &-more {
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 auto;
                border-radius: 50%;
                transform: rotate(180deg);
                box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.2);
                cursor: pointer;
                background-color: $White;

                i {
                    position: relative;
                    display: block;
                    font-size: 28px;
                    color: $Blue;
                }
            }

            &-pricings {
                border-bottom: 1px solid $ComplementaryBgTxtDarker;

                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Activities/CampCart.vue